import { Component, OnInit, ViewChild } from '@angular/core';
import { AngularFirestore } from 'angularfire2/firestore';
import { observable, Observable } from 'rxjs';
import { IPlayer } from '../../models/player';
import { ActivatedRouteSnapshot, ActivatedRoute } from '@angular/router';
import { IBid } from '../../models/bid';
import { TimeService } from '../../services/time/time.service';
import {
  FormControl,
  FormGroup,
  Validators,
  AbstractControl,
  FormGroupDirective
} from '@angular/forms';
import { BidValidators } from './bid.validators';
import { OwnerService } from '../../services/owner.service';
import { HttpHeaders, HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-player',
  templateUrl: './player.component.html',
  styleUrls: ['./player.component.css']
})
export class PlayerComponent implements OnInit {
  @ViewChild(FormGroupDirective) myForm;
  myTeam: IPlayer[] = [];
  bids: IBid[] = [];
  player: IPlayer;
  owner;
  bidForm;
  displayedColumns = ['time', 'owner', 'amount', 'years', 'totalAmount'];

  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization:
        'key=AAAAPlGjVWk:APA91bHJN0Cz_qsIhLNlgDQ2CQ4UpvhiNJPJXGvJIKs-KhkSdmaRSCyW-6wmdk3Wn1wK1uR2Ozok9_DvugN_olmC1A_hkOK4qliu-kKRSnaeDomYfMiMoEtjCjNiJFZ3FEkj_DbKt6edwIzLd7apDqALCnbKtxkzEg'
    })
  };

  constructor(
    private db: AngularFirestore,
    private route: ActivatedRoute,
    public timeService: TimeService,
    private bidValidators: BidValidators,
    private ownerService: OwnerService,
    private http: HttpClient
  ) {}

  ngOnInit() {
    this.db
      .collection('players')
      .doc(this.route.snapshot.params.id)
      .valueChanges()
      .subscribe(player => {
        this.player = player as IPlayer;
        this.buildFormGroup();
      });
    this.db
      .collection('players', ref =>
        ref.where('highestBid.owner', '==', localStorage.getItem('dffUser'))
      )
      .valueChanges()
      .subscribe(players => {
        this.myTeam = players as IPlayer[];
        this.buildFormGroup();
      });
    // this.db
    //   .collection('owners')
    //   .doc(localStorage.getItem('dffUser'))
    //   .valueChanges()
    //   .subscribe(owner => {
    //     this.owner = owner;
    //   });
    this.owner = this.ownerService.getOwner(localStorage.getItem('dffUser'));
    this.db
      .collection('bids', ref =>
        ref.where('playerId', '==', this.route.snapshot.params.id)
      )
      .valueChanges()
      .subscribe(bids => {
        const castBids = bids as IBid[];
        this.bids = castBids.sort(function(a, b) {
          return a.time - b.time;
        });
      });

    this.buildFormGroup();
  }

  buildFormGroup() {
    this.bidForm = new FormGroup(
      {
        owner: new FormControl(localStorage.getItem('dffUser')),
        amount: new FormControl('', [
          Validators.required,
          Validators.min(1),
          Validators.max(this.maxBid())
        ]),
        years: new FormControl('', [
          Validators.required,
          this.bidValidators.ValidateYears()
        ]),
        totalAmount: new FormControl({ value: '', disabled: true }, [
          Validators.required,
          this.bidValidators.MinimumTotalAmount(
            this.player && this.player.highestBid
              ? this.player.highestBid.totalAmount
              : -1
          )
        ]),
        time: new FormControl(''),
        playerId: new FormControl(this.route.snapshot.params.id)
      },
      this.bidValidators.CheapYears()
    );
  }

  bidChange() {
    this.bidForm.patchValue({
      totalAmount:
        this.bidForm.value.years * this.bidForm.value.amount +
        ((4 - this.bidForm.value.years) * this.bidForm.value.amount) / 2
    });
    this.bidForm.get('totalAmount').touched = true;
    this.bidForm.touched = true;
  }

  canBid() {
    if (!this.player) {
      return false;
    }
    if (
      this.player.highestBid &&
      this.timeService.getTimeLeftInt(
        this.player.highestBid.time,
        this.timeService.currentTimeInt
      ) < 0
    ) {
      return false;
    }
    if (
      this.player.highestBid &&
      this.player.highestBid.owner === localStorage.getItem('dffUser')
    ) {
      return false;
    }
    if (this.myTeam.length >= 17) {
      return false;
    }
    return true;
  }

  maxBid() {
    let salary = 0;
    this.myTeam.forEach(player => {
      salary += player.highestBid.amount;
    });
    return (
      245 -
      (this.owner ? this.owner.deadSalary : 0) -
      (16 - this.myTeam.length) -
      salary
    );
  }

  submitBid() {
    const previousHighBidder = this.player.highestBid
      ? this.player.highestBid.owner
      : null;
    this.bidForm.get('totalAmount').enable();
    this.bidForm.patchValue({ time: this.timeService.currentTimeInt }),
      (this.player.highestBid = this.bidForm.value);
    this.db
      .collection('bids')
      .doc(
        this.route.snapshot.params.id +
          '-' +
          localStorage.getItem('dffUser') +
          '-' +
          this.bidForm.value.time
      )
      .set(this.bidForm.value);
    this.db
      .collection('players')
      .doc(this.route.snapshot.params.id)
      .set(this.player);
    if (previousHighBidder) {
      const owner = this.ownerService.getOwner(previousHighBidder);
      owner.fcmTokens.forEach(token => {
        const requestBody = {
          notification: {
            title: 'DFF Bid Beaten',
            body:
              'Your bid on ' +
              this.player.firstName +
              ' ' +
              this.player.lastName +
              ' has been beaten.',
            click_action:
              'https://dynasty-contract-ff3.firebaseapp.com/player/' +
              this.player.firstName +
              this.player.lastName +
              this.player.team,
            'image-url':
              'http://icons.veryicon.com/png/Sport/Vista%20Style%20Sport/Football%20Ball.png'
          },
          to: token
        };

        this.http
          .post(
            'https://fcm.googleapis.com/fcm/send',
            requestBody,
            this.httpOptions
          )
          .subscribe();
      });
    }

    this.myForm.resetForm();
    this.bidForm.reset();
    this.bidForm.get('totalAmount').disable();
  }
}
